import ReactDOM from 'react-dom/client';
import { pdfjs } from 'react-pdf';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';

pdfjs.GlobalWorkerOptions.workerSrc = `/pdf.worker.min.mjs`;

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

function setRealViewHeight() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

// We listen to the resize event
window.addEventListener('resize', () => {
  // We execute the same script as before
  setRealViewHeight();
});

// We need to first set the height when the page loads
setRealViewHeight();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
